export default __webpack_public_path__ + "static/media/parking-B.1bc20007.svg";